module.exports = __webpack_public_path__ + "static/media/5.4434543b.jpg";